import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01eedb92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space-y-2 text-sm flex flex-auto flex-col p-3 pt-2" }
const _hoisted_2 = { class: "flex flex-none w-full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-auto" }, null, -1))
const _hoisted_4 = { class: "flex flex-none" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Выход", -1))

import {
  HomeIcon,
  ArrowLeftOnRectangleIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
  CubeIcon,
  BuildingLibraryIcon,
  UserCircleIcon,
  CubeTransparentIcon 
} from '@heroicons/vue/24/outline';

type TMenuLink = {
  to: string;
  title: string;
  icon: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'LeftSidebar',
  setup(__props) {

const list: TMenuLink[] = [
  {
    icon: HomeIcon,
    title: "Главная",
    to: "/"
  },
  {
    icon: ShoppingBagIcon,
    title: "Продукты",
    to: "/products"
  },
  {
    icon: CubeIcon,
    title: "Стиральные машины",
    to: "/washing-machines"
  },
  {
    icon: ShoppingCartIcon,
    title: "Прачечные",
    to: "/shops"
  },
  {
    icon: BuildingLibraryIcon,
    title: "Города",
    to: "/cities"
  },
  {
    icon: UserCircleIcon,
    title: "Менеджеры",
    to: "/managers"
  },
  {
    icon: CubeTransparentIcon,
    title: "Категории",
    to: "/categories"
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item) => {
      return _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: item.to,
          class: "sidebar-link w-full flex items-center space-x-3 text-gray-700 p-2 rounded-md font-medium hover:bg-gray-100 focus:shadow-outline"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "h-5 w-5" })),
            _createElementVNode("span", null, _toDisplayString(item.title), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      ])
    }), 64)),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        to: "/logout",
        class: "w-full flex items-center space-x-3 text-gray-700 p-2 rounded-md font-medium hover:bg-gray-200 focus:bg-gray-200 focus:shadow-outline"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowLeftOnRectangleIcon), { class: "h-5 w-5" }),
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}
}

})